import { render, staticRenderFns } from "./UkAddressComponent.vue?vue&type=template&id=f1df10d6"
import script from "./UkAddressComponent.vue?vue&type=script&lang=js"
export * from "./UkAddressComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../HCP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports